import { RoleNameMap, UserRole } from '@r-and-a-shared-ui/utils';
import { parsePPContactIdentifier } from 'libs/utils/src/lib/player-portals';
import { PPAttributes } from 'libs/auth-client/src/types/pp-user-attribute-types';

export const getAllUserRolesFromChampionship = (
  userState: any,
  championship: any,
) => {
  const championshipId = championship?.championshipIdentifier;
  if (!championshipId || !userState?.user) return [];

  const ppContacts = parsePPContactIdentifier(
    userState.user?.[PPAttributes.PPContactIdentifier],
  );

  const rolesSet = new Set<string>();
  ppContacts
    ?.filter(champ => champ.championshipId === championshipId)
    .forEach(champ => {
      champ.contactIdentifiers.forEach(contact => {
        rolesSet.add(contact.role.toLowerCase());
      });
    });

  const isRandaAdmin = userState.roles?.some(
    (role: string) => role.toLowerCase() === RoleNameMap[UserRole.RandaAdmin],
  );
  if (isRandaAdmin) {
    rolesSet.add(RoleNameMap[UserRole.RandaAdmin].toLowerCase());
  }

  return Array.from(rolesSet);
};
